<template>
  <v-container fluid>
    <v-row>
      <v-col class="col-12">
        <h1>Admin - Manage Bonus Rates</h1>
        <v-form @submit.prevent="getBonusRates">
          <v-row>
            <v-col class="col-4">
              <v-text-field
                label="Search"
                v-model="searchTerm"></v-text-field>
            </v-col>
            <v-col class="col-4">
              <v-btn type="submit">Search</v-btn>
              &nbsp;
              <v-btn @click="clearSearch">Clear</v-btn>
            </v-col>
            <v-col class="col-4 text-right">
              <router-link to="/admin/boq-bonus-rates/add">
                <v-btn>Add new BOQ Bonus Rate</v-btn>
              </router-link>
            </v-col>
          </v-row>
        </v-form>
        <v-row>
          <v-col class="col-12">
            <v-simple-table
              dense
              fixed-header
              height="450px"
            >
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Description</th>
                    <th class="text-left">Material Usage</th>
                    <th class="text-left">Bonus Rate</th>
                    <th class="text-left">Units</th>
                    <th class="text-left">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(bonusRate, index) in bonusRates"
                    :key="bonusRate.id"
                  >
                    <td>{{ bonusRate.description }}</td>
                    <td>{{ bonusRate.material_usage }}</td>
                    <td>{{ bonusRate.rate | priceInPounds | currency }}</td>
                    <td>{{ bonusRate.units }}</td>
                    <td>
                      <v-btn @click="edit(index)" x-small>Edit</v-btn>
                      &nbsp;
                      <v-btn @click="archive(index)" x-small>Archive</v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-pagination
              class="pt-4"
              v-model="page"
              :length="length"
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
              :total-visible="totalVisible"
            ></v-pagination>
            </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
  
<script>
import axios from '../../../axios';

export default {
  name: 'AdminBoqBonusRatesIndex',
  computed: {
    token() {
      return this.$store.state.token;
    },
    userid() {
      return this.$store.state.userid;
    },
  },
  data() {
    return {
      bonusRates: [],
      page: 1,
      length: 0,
      totalVisible: 9,
      searchTerm: '',
    };
  },
  watch: {
    page() {
      this.getBonusRates();
    },
  },
  methods: {
    archive(index) {
      let bonusRate = {};
      bonusRate = this.bonusRates[index].id;
      axios.get(`/bonusRates/archive/${bonusRate}.json?token=${this.token}`)
        .then((response) => {
          if (response.data === true) {
            this.bonusRates.splice(index, 1);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    edit(index) {
      let bonusRate = {};
      bonusRate = this.bonusRates[index].id;
      this.$router.push(`/admin/boq-bonus-rates/edit/${bonusRate}`);
    },
    clearSearch() {
      this.searchTerm = '';
      this.getBonusRates();
    },
    getBonusRates() {
      axios.get(`/bonusRates/getAll/${this.page}.json?token=${this.token}&term=${this.searchTerm}&userid=${this.userid}`)
        .then((response) => {
          this.bonusRates = response.data.bonusRates;
          this.length = response.data.length;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.getBonusRates();
  },
};
</script>
